import React from 'react';

import PaidIcon from '../../../../../../images/icons/green-alert-icon.svg?react';
import PartialIcon from '../../../../../../images/icons/orange-alert-icon.svg?react';
import PastDueIcon from '../../../../../../images/icons/red-alert-icon.svg?react';
import { APPLIED, COMPLETE, OPEN, PAID, PARTIAL, PAST_DUE } from '../TableConstants';

const PaymentStatus = ({ status, hasInvoiceNumber }) => {
  const resolveIcon = () => {
    switch (status) {
      case OPEN:
        return hasInvoiceNumber ? <PartialIcon data-testid="partial-icon" /> : '';
      case PAST_DUE:
        return <PastDueIcon data-testid="past-due-icon" />;
      case COMPLETE:
      case APPLIED:
      case PAID:
        return <PaidIcon data-testid="paid-icon" />;
      case PARTIAL:
        return <PartialIcon data-testid="partial-icon" />;
      default:
        return '';
    }
  };
  return resolveIcon();
};

export default PaymentStatus;
